<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UPJgKa/tc-custom/9783985312528.jpg?1703129211869" alt="This image is the cover for the book Legends of the Black Watch, or, Forty-Second Highlanders, The World At War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Legends of the Black Watch, or, Forty-Second Highlanders, The World At War
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "This soldier, whose name, from the circumstances connected with his remarkable story, daring courage, and terrible fate, is still remembered in the regiment, in the early history of which he bears so prominent a part, was one of the first who enlisted in Captain Campbell of Finab's independent band of the Reicudan Dhu, or Black Watch, when the six separate companies composing this Highland force were established along the Highland Border in 1729, to repress the predatory spirit of certain tribes, and to prevent the levy of black mail. The companies were independent, and at that time wore the clan tartan of their captains, who were Simon Frazer, the celebrated Lord Lovat; Sir Duncan Campbell of Lochnell; Grant of Ballindalloch; Alister Campbell of Finab, whose father fought at Darien; Ian Campbell of Carrick, and Deors Monro of Culcairn."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Grant
      </h2>
      
      <p class="authorDescription body article">James Grant (1822–1887) was a Scottish novelist and miscellaneous writer. Grant was born in Edinburgh, Scotland, and was a distant relation of Sir Walter Scott. He was a prolific author, writing some 90 books, including many yellow-backs. Titles included Adventures of an Aide-de-camp, One of "The six hundred", The Scottish musketeers and The Scottish cavalier.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?170dfc1c